module.exports = __webpack_public_path__ + "static/media/Apple iPhone 8 Silver.0c1948a8.png";